export default {
  SET_PROPERTY_LOCATIONS: function (state, payloads) {
    state.propertyLocations = payloads;
  },
  SET_PROPERTIES: function (state, payloads) {
    //state.properties = state.properties.concat(payloads);
    state.properties = payloads;
  },
};
